import React from 'react';
import PublicRoutes from 'src/navigation/PublicRoutes';

const PublicHome = (): React.ReactNode => {
  return <PublicRoutes />;
};

export default PublicHome;
